/**
 * Desconto da venda (percentual ou valor), com a mesma regra do servidor
 * (OrderService#applyManualDiscount no backend).
 *
 * O servidor é quem grava: ele recalcula o desconto e o divide entre os itens. Aqui o cálculo
 * existe para a tela mostrar, antes de confirmar, o mesmo total que será gravado e para
 * avisar dos limites sem esperar o erro da API.
 */
export const OrderDiscountType = {
    PERCENTAGE: 'PERCENTAGE',
    VALUE: 'VALUE'
};

/**
 * Calcula o desconto em reais sobre o valor a receber.
 *
 * subtotal é a soma dos itens já com o benefício do plano aplicado, então item zerado pelo
 * plano não entra na base, e item com desconto parcial entra só com o que sobrou.
 *
 * Retorna { value, error }: value é o desconto em reais (0 quando não há desconto ou quando ele
 * é inválido) e error é a chave de tradução do problema, ou null.
 */
export const computeOrderDiscount = (subtotal, type, informed) => {
    const amount = Number(informed) || 0;
    if (!type || amount <= 0) {
        return { value: 0, error: null };
    }

    // Em centavos, como no servidor, para o arredondamento dar o mesmo resultado nos dois lados.
    const baseCents = Math.round((Number(subtotal) || 0) * 100);
    if (baseCents <= 0) {
        return { value: 0, error: 'validation.custom.order_discount_nothing_to_discount' };
    }

    let discountCents;
    if (type === OrderDiscountType.PERCENTAGE) {
        // 100% não é desconto: venda que não cobra nada é Cortesia, que já é forma de pagamento.
        if (amount >= 100) {
            return { value: 0, error: 'validation.custom.order_discount_percentage_limit' };
        }
        discountCents = Math.round(baseCents * amount / 100);
    } else {
        discountCents = Math.round(amount * 100);
    }

    if (discountCents >= baseCents) {
        return { value: 0, error: 'validation.custom.order_discount_value_limit' };
    }

    return { value: discountCents / 100, error: null };
};
